interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel: string;
  size?: 'sm' | 'md';
}

export function Toggle({
  checked,
  onChange,
  disabled = false,
  ariaLabel,
  size = 'md',
}: ToggleProps) {
  const sizeClasses = size === 'sm' 
    ? 'h-4 w-7 after:h-3 after:w-3' 
    : 'h-5 w-9 after:h-4 after:w-4';

  return (
    <label className="relative inline-flex cursor-pointer items-center">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="peer sr-only"
        aria-label={ariaLabel}
      />
      <div
        className={`
          ${sizeClasses}
          rounded-full bg-surface-darker
          after:absolute after:start-[2px] after:top-[2px]
          after:rounded-full after:bg-white
          after:transition-all after:content-['']
          peer-checked:bg-primary peer-checked:after:translate-x-full
          peer-focus:ring-2 peer-focus:ring-primary/20
          peer-disabled:cursor-not-allowed peer-disabled:opacity-50
        `}
      />
    </label>
  );
}
